"use client";

import dynamic from "next/dynamic";

export const landingComponentRegistry = {
    slider: dynamic(() => import("./components/slider.lc")),
    space: dynamic(() => import("./components/space.lc")),
    footer: dynamic(() => import("./components/footer.lc")),
    benefits: dynamic(() => import("./components/benefits.lc")),
    banner: dynamic(() => import("./components/banner.lc")),
    block: dynamic(() => import("./components/block.lc")),
    quill: dynamic(() => import("./components/quill.lc")),
    video: dynamic(() => import("./components/video.lc")),
    timeline: dynamic(() => import("./components/timeline.lc")),
    faq: dynamic(() => import("./components/faq.lc")),
    image: dynamic(() => import("./components/image.lc")),
    icon: dynamic(() => import("./components/icon.lc")),
    text: dynamic(() => import("./components/text.lc")),
    "section-header": dynamic(() => import("./components/section-header.lc")),
    "info-card": dynamic(() => import("./components/infoCard.lc")),
    cta: dynamic(() => import("./components/cta.lc")),
    "price-range": dynamic(() => import("./components/priceRange.lc")),
    chip: dynamic(() => import("./components/chip.lc")),
    "image-tabs": dynamic(() => import("./components/imageTabs.lc")),
    "product-tabs": dynamic(() => import("./components/productTabs.lc")),
    quiz: dynamic(() => import("./components/quiz.lc")),
    advisor: dynamic(() => import("./components/advisor.lc")),
    "video-playlist": dynamic(() => import("./components/videoPlaylist.lc")),
    "scroll-video-tabs": dynamic(() => import("./components/scrollVideoTabs.lc")),
    "vertical-video-slider": dynamic(() => import("./components/verticalVideoSlider.lc")),
    "product-family": dynamic(() => import("./components/productFamily.lc")),
    authenticity: dynamic(() => import("./components/authenticity.lc")),
    table: dynamic(() => import("./components/table.lc")),
    hero: dynamic(() => import("./components/hero.lc")),
};

// Components whose children are sized from the container width. Swiper writes a pixel
// width onto every slide, so a cell that shrink-wraps its children (a column cell with
// align_items: center) makes the component measure itself, grow, and measure again --
// it runs away until it hits the root max-width. These have to fill their cell.
export const fullWidthLandingComponents: ReadonlySet<string> = new Set([
    "slider",
    "timeline",
    "vertical-video-slider",
    "table",
    "product-tabs",
]);

export type LandingComponentRegistryName = keyof typeof landingComponentRegistry;

export function getLandingComponent(name: string) {
    return landingComponentRegistry[name as LandingComponentRegistryName] ?? null;
}
